import React, { Component } from 'react';
import {setContextualHelp} from "actions/index.js";
import {GRAPHICAL_KEYBOARD} from 'constants/contextual-help.js';
import { connect } from "react-redux";
import AbstractKey from './AbstractKey.js';
import Colors from 'Colors.js';
const colors = new Colors();

class Key extends AbstractKey {
    constructor(props) {
        super(props);
    }

    get mappings() {
        if (this.props.keyboardEngine === undefined) {
            return {};
        }
        return this.props.keyboardEngine.getMappings();
    }

    onClickKey() {
        // when the user clicks a key, we should select that track
        let trackNumber = this.props.trackNumber === undefined ?
            this.props.selectedTrack : this.props.trackNumber;
        if (this.isSample(trackNumber)) {
            if (this.props.keyboardEngine.hasKeyMapping(this.key)) {
                // if user is on detail view, clicking deletes the mapping,
                // if there is one
                this.props.keyboardEngine.deleteKeyMapping(this.key);
            } else {
                // otherwise it maps the current slice to that
                this.props.keyboardEngine.map(
                    this.key, trackNumber, this.props.selectedSlice);
            }
        }
    }

    render() {
        let className = this.props.mini ? 'key mini' : 'key';
        if (this.props.triggering) {
            className += ' flashit';
        }
        if (this.props.keyMapping) {
            if (this.props.selectedTrack === this.props.keyMapping.trackNumber) {
                className += " selected-track";
            }
        }
        return (<div
                onClick={() => this.onClickKey()}
                style={this.getStyle()} className={className}>{this.props.value}</div>);
    }
}

const mapStateToProps = (state, props) => {
    let keyMapping = state.keyboard.keyMappings[props.keyboardKey];
    let trackTriggers = keyMapping === undefined ? undefined :
        state.tracks.triggers[keyMapping.trackNumber];
    let triggering = trackTriggers === undefined ? false :
        trackTriggers[keyMapping.sliceNumber];
    let id = undefined;
    if (keyMapping) {
        let track = props.sequencerEngine.tracks[keyMapping.trackNumber];
        if (track) {
            id = track.getIdentifier();
        }
    }
    return {
        id,
        triggering: triggering,
        keyMapping: keyMapping,
        selectedTrack: state.mix.selectedTrack
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Key);
